// // SuperAdminSidebar.jsx - Sidebar for SuperAdmin
// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import {
//   Sidebar,
//   SidebarHeader,
//   SidebarContent,
//   SidebarMenu,
//   SidebarMenuItem,
//   SidebarMenuButton,
//   SidebarFooter,
//   SidebarGroup,
//   SidebarGroupLabel,
// } from '../sidebar';

// import {
//   LayoutDashboard, Users, CreditCard, BarChart3, Settings, LogOut, 
//   Shield, Activity, FileText, Database, UserCog, TrendingUp
// } from 'lucide-react';

// import { cn } from '../../../lib/utils';

// const SuperAdminLogo = () => (
//   <Link to="/admin/dashboard" className="flex items-center gap-2 px-2 py-1 text-lg font-semibold">
//     <Shield className="h-8 w-8 text-red-600" />
//     <div>
//       <span className="text-red-600 font-bold">InvoiceCraft</span>
//     </div>
//   </Link>
// );

// const SuperAdminIcon = () => (
//   <Shield className="h-7 w-7 text-red-600" />
// );

// export function AppSidebar() {
//   const { pathname } = useLocation();

//   const adminMenuItems = [
//     { href: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
//        { href: '/admin/licenses', label: 'Assign Tickets', icon: CreditCard },
//     { href: '/admin/analytics', label: 'Branding', icon: BarChart3 },
//      ];

//   const isActive = (href) => {
//     return pathname === href || pathname.startsWith(href + '/');
//   };

//   const handleLogout = () => {
//     localStorage.removeItem('superadmin_token');
//     localStorage.removeItem('admin_user');
//     window.location.href = '/';
//   };

//   return (
//     <Sidebar variant="sidebar" collapsible="icon" className="border-r-2 border-red-100">
//       <SidebarHeader className="border-b border-red-100">
//         <div className="flex h-16 items-center justify-start group-data-[collapsible=icon]:justify-center">
//           <div className="group-data-[collapsible=icon]:hidden">
//             <SuperAdminLogo />
//           </div>
//           <div className="hidden group-data-[collapsible=icon]:block">
//             <SuperAdminIcon />
//           </div>
//         </div>
//       </SidebarHeader>

//       <SidebarContent className="flex-1">
//         {/* Main Admin Menu */}
//         <SidebarMenu>
//           {adminMenuItems.map((item) => (
//             <SidebarMenuItem key={item.href}>
//               <SidebarMenuButton
//                 asChild
//                 isActive={isActive(item.href)}
//                 tooltip={item.label}
//                 className={cn(
//                   "justify-start hover:bg-red-50",
//                   { 'bg-red-100 text-red-700 hover:bg-red-150': isActive(item.href) }
//                 )}
//               >
//                 <Link to={item.href}>
//                   <item.icon className="h-5 w-5" />
//                   <span>{item.label}</span>
//                 </Link>
//               </SidebarMenuButton>
//             </SidebarMenuItem>
//           ))}
//         </SidebarMenu>

      
//       </SidebarContent>

//       <SidebarFooter className="border-t border-red-100 p-2">
//         <SidebarMenu>
//           <SidebarMenuItem>
//             <SidebarMenuButton 
//               onClick={handleLogout}
//               tooltip="Logout" 
//               className="justify-start w-full hover:bg-red-50 text-red-600 hover:text-red-700"
//             >
//               <LogOut className="h-5 w-5" />
//               <span>Logout</span>
//             </SidebarMenuButton>
//           </SidebarMenuItem>
//         </SidebarMenu>
//       </SidebarFooter>
//     </Sidebar>
//   );
// }

// AppSidebar.displayName = "AppSidebar";


// AppSidebar.jsx - Simple Sidebar matching screenshots
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Sidebar,
  SidebarHeader,
  SidebarContent,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  SidebarFooter,
} from '../sidebar';

import {
  LayoutDashboard, CreditCard, Palette, LogOut, Shield
} from 'lucide-react';

import { cn } from '../../../lib/utils';

const SuperAdminLogo = () => (
  <Link to="/admin/dashboard" className="flex items-center gap-3 px-4 py-3">
   <div className="flex items-center">
    <img 
              src="/Artboard 1 copy 11@2x (1).png" 
              alt="evolvv Hub Logo" 
              className="h-8 w-auto object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling.style.display = 'flex';
              }}
            />
    </div>
    
  </Link>
);

export function AppSidebar() {
  const { pathname } = useLocation();

  const menuItems = [
    { href: '/Dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { href: '/Ticket-Mangament', label: 'Assign Tickets', icon: CreditCard },
    { href: '/Branding', label: 'Branding', icon: Palette },
  ];

  const isActive = (href) => {
    return pathname === href || pathname.startsWith(href + '/');
  };

  const handleLogout = () => {
    localStorage.removeItem('superadmin_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/';
  };

  return (
    <Sidebar className="border-r border-gray-200 bg-white ">
      {/* Header */}
      <SidebarHeader className="border-b border-gray-200 p-0 h-15">
        <SuperAdminLogo />
      </SidebarHeader>

      {/* Content */}
      <SidebarContent className="p-2">
        <SidebarMenu className="space-y-2">
          {menuItems.map((item) => (
            <SidebarMenuItem key={item.href}>
              <SidebarMenuButton
                asChild
                className={cn(
                  "w-full h-12 justify-start rounded-lg px-4 py-3 text-gray-700 hover:bg-gray-100 transition-colors",
                  {
                    'bg-primary/10 text-primary hover:bg-primary/20 dark:bg-primary/20 dark:text-primary dark:hover:bg-primary/30': isActive(item.href)
                  }
                )}
              >
                <Link to={item.href} className="flex items-center gap-3">
                  <item.icon className="h-5 w-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarContent>

      {/* Footer */}
      <SidebarFooter className="p-4 border-t border-gray-200 mt-auto">
        
        
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton 
              onClick={handleLogout}
              className="w-full h-10 justify-start rounded-lg px-3 text-red-600 hover:bg-red-50 hover:text-red-700 transition-colors"
            >
              <LogOut className="h-4 w-4 mr-2" />
              <span className="font-medium">Logout</span>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  );
}

AppSidebar.displayName = "AppSidebar";